/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');

const Q_at_board_edge = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.slam = BattleCalc.getEquippedAbility(actor, 'slam');

  node.branches[node.NO] = node.slam
    ? new UseAbility({
        actor,
        abilityHandle: 'slam',
        altNode: node.branches[node.YES],
      })
    : new TreeNode(null, null);

  node.branches[node.YES] = new TreeNode(null, null);

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.slam = null;
    originalDispose.call(node);
  };

  node.yesNoEvalFunction = function (target) {
    return BattleCalc.targetIsAtBoardEdge(actor, target, battleState);
  };

  return node;
};
module.exports = Q_at_board_edge;
